import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "d-flex flex-column justify-content-center align-items-center text-light h-100"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BImg = _resolveComponent("BImg")
  const _component_BCarouselSlide = _resolveComponent("BCarouselSlide")
  const _component_BCarousel = _resolveComponent("BCarousel")
  const _component_BModal = _resolveComponent("BModal")

  return (_openBlock(), _createBlock(_component_BModal, {
    modelValue: $data.open,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.open) = $event)),
    size: "lg",
    fullscreen: "sm",
    title: $data.title,
    "modal-class": "image-viewer",
    "header-text-variant": "light",
    "header-close-class": "btn-close-white",
    "no-footer": ""
  }, {
    default: _withCtx(() => [
      ($data.open)
        ? (_openBlock(), _createBlock(_component_BCarousel, _mergeProps({
            key: 0,
            modelValue: $data.slide,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.slide) = $event))
          }, $options.carouselProps), {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.images, (image, index) => {
                return (_openBlock(), _createBlock(_component_BCarouselSlide, {
                  key: image.id,
                  background: "transparent"
                }, {
                  img: _withCtx(() => [
                    (!$data.error[index])
                      ? (_openBlock(), _createBlock(_component_BImg, {
                          key: 0,
                          class: _normalizeClass({'placeholder placeholder-wave': $data.loading[index]}),
                          src: image.url,
                          alt: image.alt,
                          placement: "center",
                          onLoad: $event => ($data.loading[index] = false),
                          onError: $event => ($options.onImageError(index))
                        }, null, 8 /* PROPS */, ["class", "src", "alt", "onLoad", "onError"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("i", { class: "fa fa-triangle-exclamation fa-2x mb-2" }, null, -1 /* CACHED */),
                          _createElementVNode("span", null, "Das Bild konnte nicht geladen werden.", -1 /* CACHED */)
                        ]))]))
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 16 /* FULL_PROPS */, ["modelValue"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "title"]))
}